
export default function Privacy() {
  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-20 h-20 mx-auto mb-8 bg-teal-500 rounded-2xl flex items-center justify-center">
          <i className="ri-shield-check-line text-3xl text-white"></i>
        </div>
        
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-8">
          Deine Privatsphäre steht an erster Stelle
        </h2>
        
        <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-12">
          Mindshift AI ist vollständig DSGVO-konform. Alle Daten werden verschlüsselt 
          und ausschließlich in Deutschland gehostet – höchste Datenschutzstandards garantiert.
        </p>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-800 rounded-xl flex items-center justify-center">
              <i className="ri-lock-password-line text-2xl text-teal-400"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Ende-zu-Ende-Verschlüsselung</h3>
            <p className="text-gray-400">Alle Nachrichten und Daten sind vollständig verschlüsselt</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-800 rounded-xl flex items-center justify-center">
              <i className="ri-map-pin-line text-2xl text-teal-400"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Deutschland-Hosting</h3>
            <p className="text-gray-400">Server ausschließlich in Deutschland – DSGVO-konform</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-800 rounded-xl flex items-center justify-center">
              <i className="ri-user-settings-line text-2xl text-teal-400"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Daten-Minimierung</h3>
            <p className="text-gray-400">Nur notwendige Daten – volle Kontrolle über deine Informationen</p>
          </div>
        </div>

        {/* Additional Security Info */}
        <div className="mt-12 bg-gray-800 rounded-2xl p-8">
          <h4 className="text-2xl font-bold text-white mb-4">
            <i className="ri-shield-star-line mr-2 text-teal-400"></i>
            Unsere Sicherheitsmaßnahmen
          </h4>
          <div className="grid md:grid-cols-2 gap-6 text-left">
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-teal-400 mr-3 mt-1"></i>
              <div>
                <p className="text-white font-semibold">Pseudonymisierung</p>
                <p className="text-gray-400 text-sm">Keine Klarnamen erforderlich – optional nutzbar</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-teal-400 mr-3 mt-1"></i>
              <div>
                <p className="text-white font-semibold">Regelmäßige Sicherheits-Audits</p>
                <p className="text-gray-400 text-sm">Kontinuierliche Überprüfung unserer Systeme</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-teal-400 mr-3 mt-1"></i>
              <div>
                <p className="text-white font-semibold">Transparente Datennutzung</p>
                <p className="text-gray-400 text-sm">Du weißt immer, welche Daten wir speichern</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-teal-400 mr-3 mt-1"></i>
              <div>
                <p className="text-white font-semibold">Löschrecht jederzeit</p>
                <p className="text-gray-400 text-sm">Deine Daten können jederzeit gelöscht werden</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
